import {
  GET_FAQ_CATEGORIES_ADMINTOOLS,

  GET_FAQ_DETAIL_ADMINTOOLS,
  GET_FAQ_DETAIL_CATEGORY_ADMINTOOLS,
  GET_FAQ_DETAIL_GROUP_ADMINTOOLS,
  GET_FAQ_GROUPS_ADMINTOOLS,
  GET_FAQ_GROUPS_OPTION_ADMINTOOLS,
  RESET_FAQ_DETAIL_ADMINTOOLS,
} from 'shared/constants/ActionTypes';

const initialState = {
  detailFaq: null,
  detailFaqCategory: null,
  detailFaqGroup: null,
  categories: null,
  groups: null,
};

const faqAdmintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAQ_DETAIL_CATEGORY_ADMINTOOLS:
      return {
        ...state,
        detailFaqCategory: action.payload,
      };
    case GET_FAQ_DETAIL_GROUP_ADMINTOOLS:
      return {
        ...state,
        detailFaqGroup: action.payload,
      };
    case GET_FAQ_DETAIL_ADMINTOOLS:
      return {
        ...state,
        detailFaq: action.payload,
      };
    case GET_FAQ_GROUPS_OPTION_ADMINTOOLS:
      return {
        ...state,
        groups: action.payload,
      };
    case GET_FAQ_CATEGORIES_ADMINTOOLS:
      return {
        ...state,
        categories: action.payload,
      };
    case GET_FAQ_GROUPS_ADMINTOOLS:
      return {
        ...state,
        groups: action.payload,
      };
    default: {
      return state;
    }

    case RESET_FAQ_DETAIL_ADMINTOOLS:
      return initialState;
  }
};

export default faqAdmintoolsReducer;
